<template>
<Header />
          <!-- catalog -->
        <div class="catalog">
            <div class="container">
                <div class="row" >
                    <div class="col-12">
                        <div class="row row--grid" style="margin-top: 50px;">
                            <div class="col-12 col-md-6 col-xl-4" v-for="sear in GetSearch" :key="sear.id">
                                <div class="card card--big" >
                                  <div class="row">

                                    <div class="col-6">
                                    <a @click="getFeed(sear)" class="card__cover pointer" style="border-radius: 0px 16px 16px 0px; padding: 0px;width: 95%;">
                                        <img :src="sear.img" alt="">
                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 1C16.5228 1 21 5.47716 21 11C21 16.5228 16.5228 21 11 21C5.47716 21 1 16.5228 1 11C1 5.47716 5.47716 1 11 1Z" stroke-linecap="round" stroke-linejoin="round"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0501 11.4669C13.3211 12.2529 11.3371 13.5829 10.3221 14.0099C10.1601 14.0779 9.74711 14.2219 9.65811 14.2239C9.46911 14.2299 9.28711 14.1239 9.19911 13.9539C9.16511 13.8879 9.06511 13.4569 9.03311 13.2649C8.93811 12.6809 8.88911 11.7739 8.89011 10.8619C8.88911 9.90489 8.94211 8.95489 9.04811 8.37689C9.07611 8.22089 9.15811 7.86189 9.18211 7.80389C9.22711 7.69589 9.30911 7.61089 9.40811 7.55789C9.48411 7.51689 9.57111 7.49489 9.65811 7.49789C9.74711 7.49989 10.1091 7.62689 10.2331 7.67589C11.2111 8.05589 13.2801 9.43389 14.0401 10.2439C14.1081 10.3169 14.2951 10.5129 14.3261 10.5529C14.3971 10.6429 14.4321 10.7519 14.4321 10.8619C14.4321 10.9639 14.4011 11.0679 14.3371 11.1549C14.3041 11.1999 14.1131 11.3999 14.0501 11.4669Z" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                    </a>
                                    
                                    </div>

                                    <div class="col-6">
                                      <div class="">
                                        <h3 class="card__title pointer" style="margin-top: 13%;"><a @click="getFeed(search)">{{ sear.title_ar}}</a></h3>
                                        <p class="card__tagline pointer" @click="getFeed(sear)" style="margin-top: 10px;">{{ sear.desc_ar}}</p>
                                    </div>
                                    </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12" v-if="GetSearch == null">
                    <div class="row row--grid" style="margin-top:40px;justify-content: center;">
                    
                    <div class="search-message-empty-container" dir="ltr" style="color:#0a6069;padding-right:15px;margin-bottom:calc(50vh - 25%);font-size:75%;font-family:'Cairo', sans-serif;">
  <span class="search-message-empty-decal">
    <span class="search-message-empty-decal-eyes">:</span>
    <span>(</span>
  </span>
  <h2 class="search-message-empty-message">
    عذرا لم نجد نتائج بحث  
  </h2>
</div>
                    </div>
                    
                    </div>
                </div>		
            </div>
        </div>
        <!-- end catalog -->
<Footer />
</template>

<script>
import axios from "axios";
import Header from "@/components/Include/Header.vue";
import Footer from "@/components/Include/Footer.vue";
import config from '@/Api/config';

export default {
   name: 'Search',
   props: ["search"],
   data() {
    return {
        GetSearch: null,
        propChanged: this.search
    };
  },
   components: {
    Header,
    Footer
  },
    // watch: { 
    //     search: function(newVal, oldVal) { // watch it
    //        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
    //        if (newVal !== oldVal) {
    //            this.propChanged = newVal
    //            this.$router.go()
    //        }
    //     }
    // },
    
 async mounted() {

  
     try {
       await axios
      .get("GetSearchContent.php?search="+this.propChanged,{
           headers: {
               'Authorization': config.authHeader,
            },
      })
      .then((response) => (this.GetSearch = response.data.Content));
     } catch(err) {
        alert(err);
     }  
  },
  methods: {

    

    getFeed: function (search) {
      this.$cookie.setCookie('Content_id', search.id);
      this.$cookie.setCookie('cat_id', search.cat_id);
      if (this.$cookie.isCookieAvailable("minutes") && this.$cookie.isCookieAvailable("mdn")) {
        axios.get(
            "CheckUserCategory.php?msisdn="+this.$cookie.getCookie("mdn")+"&product_code="+search.cat_id
            ,{
           headers: {
               'Authorization': config.authHeader,
            },
      }).then((response) => {
              if (response.data.MINTUES > 0) {
                this.$router.push("/Content");
              } else {
                this.$router.push("/Trailer");
              }
          });
         
      } else {
        this.$router.push("/Trailer");
      }
    },
  },
}
</script>

<style>
.pointer {
  cursor: pointer;
}
.search-message-empty-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-left: 4.5em;
}

.search-message-empty-decal {
  margin-right: 2rem;
  font-size: 6rem;
  transform: rotate(90deg);
}

.search-message-empty-message {
  font-size: 1.5em;
  text-rendering: optimizeLegibility;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>